import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Avatar, Box, Button, Container, Divider, Grid, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';

import { JohnPhoto, LogoFnl2cHorzC, SammyPhoto } from '@/assets';
import { muiPalette } from '@/shared/general-theme';

const TEAM_PROFILES = [
  {
    name: 'John Steven',
    role: 'Principal Consultant',
    img: JohnPhoto,
    linkedinUrl: 'https://www.linkedin.com/in/m1splacedsoul/',
  },
  {
    name: 'Sammy Migues',
    role: 'Principal Consultant',
    img: SammyPhoto,
    linkedinUrl: 'https://www.linkedin.com/in/sammymigues/',
  },
];

const WelcomeFooter: React.FC = () => {
  return (
    <Box sx={{ backgroundColor: '#070c14', pt: 12, pb: 6, borderTop: `1px solid ${muiPalette.grey[800]}` }}>
      <Container maxWidth='lg'>
        <Grid container spacing={8}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant='h3' sx={{ color: 'white', mb: 3, fontWeight: 700 }}>
              Partner with Aedify
            </Typography>
            <Typography
              variant='body1'
              sx={{ color: muiPalette.grey[300], mb: 4, fontSize: '1.1rem', lineHeight: 1.7 }}
            >
              Our approach is collaborative and tailored. We work alongside your teams, providing
              expertise and support to build resilient product security programs. Let's discuss your
              current program and your best next steps.
            </Typography>
            <Button
              variant='contained'
              size='large'
              startIcon={<CalendarMonthIcon />}
              sx={{
                backgroundColor: muiPalette.secondary.main,
                borderColor: muiPalette.secondary.main,
                px: 4, py: 2,
                fontSize: '1rem',
                '&:hover': {
                  backgroundColor: muiPalette.secondary.dark,
                  borderColor: muiPalette.secondary.dark,
                },
              }}
              onClick={() => window.open('https://calendly.com/osc-principals', '_blank')}
            >
              Schedule a Consultation
            </Button>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant='h6' sx={{ color: 'white', mb: 4, fontWeight: 700 }}>
              Meet the Experts
            </Typography>
            <Stack spacing={4}>
              {TEAM_PROFILES.map((profile) => (
                <Stack key={profile.name} direction='row' spacing={2} alignItems='center'>
                  <Avatar
                    src={profile.img}
                    alt={profile.name}
                    sx={{ width: 64, height: 64, border: `2px solid ${muiPalette.primary.main}` }}
                  />
                  <Box sx={{ flex: 1 }}>
                    <Typography variant='h6' color='white'>{profile.name}</Typography>
                    <Typography variant='body2' color={muiPalette.grey[400]}>{profile.role}</Typography>
                  </Box>
                  <IconButton
                    color='primary'
                    onClick={() => window.open(profile.linkedinUrl, '_blank')}
                  >
                    <LinkedInIcon sx={{ fontSize: '1.75rem' }} />
                  </IconButton>
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Box sx={{ mt: 12, pt: 4, borderTop: `1px solid ${muiPalette.grey[800]}`, textAlign: 'center' }}>
          <Stack spacing={2}>
            <Box
              component='div'
              sx={{
                fontWeight: 800,
                fontSize: '1.5rem',
                letterSpacing: '-0.02em',
                color: muiPalette.primary.main,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              <LogoFnl2cHorzC
                style={{
                  height: '2rem',
                }}
              />
              <Divider
                orientation='vertical' flexItem sx={{
                mx: 2,
                height: '1.5rem',
                alignSelf: 'center',
                borderColor: muiPalette.grey[600],
              }}
              />
              PLATYPUS<span style={{ color: muiPalette.tertiary.main }}>.</span>
            </Box>
            <Typography variant='body2' color={muiPalette.grey[400]}>
              © 2026 Aedify Security LLC. All rights reserved.
            </Typography>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default WelcomeFooter;
